import React, { useEffect, useState } from "react";
import "./styles.scss";
import PropTypes from "prop-types";

function OtpInput(props) {
  const { timeInterval, displayCountdown, onCountdownFinish } = props;
  const [seconds, setSeconds] = useState(timeInterval);
  const [isCountdownActive, setIsCountdownActive] = useState(displayCountdown);

  useEffect(() => {
    let interval = null;
    if (isCountdownActive && seconds !== 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else {
      if (isCountdownActive && seconds === 0) {
        setIsCountdownActive(false);
        onCountdownFinish(true);
      }
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isCountdownActive, seconds]);

  useEffect(() => {
    if (displayCountdown && seconds === 0) {
      setIsCountdownActive(true);
      setSeconds(timeInterval);
    }
  }, [displayCountdown]);

  return (
    <div>
      {isCountdownActive && (
        <>
          <div>00:{`${seconds}`}</div>
        </>
      )}
    </div>
  );
}

OtpInput.propTypes = {
  numberOfInputs: PropTypes.number.isRequired,
  onOtpEnter: PropTypes.func.isRequired,
  displayCountdown: PropTypes.bool.isRequired,
  timeInterval: PropTypes.number,
  onCountdownFinish: PropTypes.func,
  countdownText: PropTypes.string,
};

export default OtpInput;
